import { Component, OnDestroy } from '@angular/core'
import { ActiveCartFacade, DeliveryMode } from '@spartacus/cart/base/root'
import { B2BCheckoutReviewSubmitComponent } from '@spartacus/checkout/b2b/components'
import { CheckoutCostCenterFacade, CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root'
import { CheckoutStepService } from '@spartacus/checkout/base/components'
import {
  CheckoutDeliveryAddressFacade,
  CheckoutDeliveryModesFacade,
  CheckoutPaymentFacade,
  CheckoutStepType
} from '@spartacus/checkout/base/root'
import {
  Address,
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  TranslationService,
  UserCostCenterService
} from '@spartacus/core'
import { Card } from '@spartacus/storefront'
import { BehaviorSubject, Observable, Subscription } from 'rxjs'
import { EbAvailabilityItem } from 'src/app/features/product/interfaces/eb-availability.interface'
import { EbAvailabilityService } from 'src/app/features/product/services/facades/eb-availability.service'
import { EB_ICON_TYPE } from '../../../../components/icons/interface/eb-icon-type.enum'
import { EbCart } from '../../../cart/interface/eb-cart.interface'
import { EbCardConstructorService } from '../../services/eb-card-constructor.service'

@Component({
    selector: 'eb-review-submit',
    templateUrl: './eb-review-submit.component.html',
    styleUrls: ['./eb-review-submit.component.scss'],
    standalone: false
})
export class EbReviewSubmitComponent extends B2BCheckoutReviewSubmitComponent implements OnDestroy {
  public isValidatingShippingDate$ = new BehaviorSubject(false)
  private subscription = new Subscription()
  checkoutStepType_DELIVERY_ADDRESS = CheckoutStepType.DELIVERY_ADDRESS
  checkoutStepType_DELIVERY_MODE = CheckoutStepType.DELIVERY_MODE
  checkoutStepType_PAYMENT_DETAILS = CheckoutStepType.PAYMENT_DETAILS
  checkoutStepType_PAYMENT_TYPE = CheckoutStepType.PAYMENT_TYPE
  /*
   * core method in review-submit
   * change: custom type EbCart
   */
  get cart$(): Observable<EbCart> {
    return this.activeCartFacade.getActive()
  }

  get IconType() {
    return EB_ICON_TYPE
  }

  getShippingDate(): Date {
    let shippingDate = null
    this.cart$.subscribe(cart => {
      shippingDate = cart.requestedShippingDate
    })
    return shippingDate
  }

  constructor(
    checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    checkoutPaymentFacade: CheckoutPaymentFacade,
    activeCartFacade: ActiveCartFacade,
    translationService: TranslationService,
    checkoutStepService: CheckoutStepService,
    checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
    checkoutPaymentTypeFacade: CheckoutPaymentTypeFacade,
    checkoutCostCenterFacade: CheckoutCostCenterFacade,
    userCostCenterService: UserCostCenterService,
    protected cardConstructor: EbCardConstructorService,
    protected availabilityService: EbAvailabilityService,
    protected routingService: RoutingService,
    protected globalMessageService: GlobalMessageService
  ) {
    super(
      checkoutDeliveryAddressFacade,
      checkoutPaymentFacade,
      activeCartFacade,
      translationService,
      checkoutStepService,
      checkoutDeliveryModesFacade,
      checkoutPaymentTypeFacade,
      checkoutCostCenterFacade,
      userCostCenterService
    )
    this.checkValidationEvent()
    this.validateAvailabilityDates()
  }

  getShippingAddressCard(deliveryAddress: Address): Observable<Card> {
    return this.cardConstructor.getShippingAddressCard(deliveryAddress)
  }

  getInvoiceAddressCard(invoiceAddress: Address): Observable<Card> {
    return this.cardConstructor.getInvoiceAddressCard(invoiceAddress)
  }

  /*
   * core function in review-submit
   * change: hardcoded i18n key
   */
  getDeliveryCard(
    deliveryMode: DeliveryMode,
    shippingDate: string,
    completeDelivery = true,
    loading?: boolean
  ): Observable<Card> {
    return this.cardConstructor.getDeliveryCard(
      deliveryMode,
      shippingDate,
      completeDelivery,
      loading
    )
  }

  /*
   * core function in review-submit
   * change: hardcoded i18n key
   */
  getPaymentTypeCard(): Observable<Card> {
    return this.cardConstructor.getPaymentTypeCard()
  }

  validateAvailabilityDates() {
    this.availabilityService.emitValidatingShippingDateEvent(true)
    this.subscription.add(
      super.entries$.subscribe(entries => {
        const ebProductAvailabilityItems: EbAvailabilityItem[] = entries.map(entry => ({
          product: entry.product.code,
          quantity: entry.quantity
        }))
        this.subscription.add(
          this.availabilityService
            .fetchAvailabilities(
              ebProductAvailabilityItems,
              true,
              this.getShippingDate()?.toString().split('T')[0]
            )
            .subscribe(data => {
              this.availabilityService.emitValidatingShippingDateEvent(false)
              if (data.revalidateShippingDate === true) {
                this.globalMessageService.add(
                  {
                    key: 'checkoutReview.shippingDate.error'
                  },
                  GlobalMessageType.MSG_TYPE_WARNING
                )
                this.routingService.go({
                  cxRoute: super.getCheckoutStepUrl(CheckoutStepType.DELIVERY_MODE)
                })
              }
            })
        )
      })
    )
  }

  checkValidationEvent() {
    this.subscription.add(
      this.availabilityService.validatingShippingDateEvent.subscribe((validating: boolean) => {
        this.isValidatingShippingDate$.next(validating)
      })
    )
  }
  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}
